<job-search-filters-mobile-menu #jobSearchFilterMenu [(availableFilters)]="filters" [themeColor]="themeColor" (applyFilters)="updateQueryParams()" (resetAllFilters)="resetAllFilters()">
</job-search-filters-mobile-menu>

<div id="job-results" class="container" #jobResults>

    <!-- This is the list header with StickyScroll -->
    <div StickyScroll [top]="true" [mobileOnly]="true" *ngIf="hasListSearched && currentViewType === 'list'">
        <ng-container *ngTemplateOutlet="searchResultsHeaderContent;context:this"></ng-container>
    </div>

    <!-- This is the map header without StickyScroll but fixed on mobile -->
    <div id="search-results-header-map" *ngIf="currentViewType === 'map'">
        <ng-container *ngTemplateOutlet="searchResultsHeaderContent;context:this"></ng-container>
    </div>

    <ng-template #searchResultsHeaderContent>
        <div class="row">
            <div class="col-sm-12">
                <h3 class="ql-align-center">
                    <span [style.color]="themeColor" class="search-head">Open Jobs</span>
                </h3>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-4">
                <form role="form" [formGroup]="jobSearch" (ngSubmit)="updateQueryParams()" novalidate autocomplete="off" id="form-container-left">
                    <div class="form-group">
                        <div class="input-group">
                            <span class="input-group-addon geolocation hidden-xs hidden-sm" *ngIf="geoLocationService.hasGeoCapabilities()" (click)="getLatLngFromGeoLocation()">
                                <i class="icon icon-target"></i>
                            </span>
                            <input type="text" class="form-control" name="location" placeholder="Search City and State or Zipcode" aria-label="Search City and State or Zipcode" *ngIf="geoLocationService.hasGeoCapabilities()" [formControl]="location" (focus)="toggleLocationDropdownAnimatedState()" (blur)="toggleLocationDropdownAnimatedState()">
                            <input type="text" class="form-control" name="location" placeholder="Search City and State or Zipcode" aria-label="Search City and State or Zipcode" *ngIf="!geoLocationService.hasGeoCapabilities()" [formControl]="location">
                            <span *ngIf="!isSearching" class="input-group-addon" style="border-radius: 0 4px 4px 0;" (click)="updateQueryParams()">
                                <i class="icon icon-search" aria-hidden="true"></i>
                            </span>
                            <span *ngIf="isSearching" class="input-group-addon">
                                <i class="icon icon-spinner" aria-hidden="true"></i>
                            </span>
                        </div>
                    </div>

                    <div id="location-dropdown" *ngIf="geoLocationService.hasGeoCapabilities()" class="hidden-md hidden-lg" (click)="getLatLngFromGeoLocation()" [class.open]="locationDropdownAnimatedState">
                        <div id="location-dropdown-content">
                            <div id="location-dropdown-content-find-me">
                                <i class="icon icon-target"></i>Search jobs near me</div>
                        </div>
                    </div>
                </form>

                <div>
                    <span id="job-search-bar-view-toggle">
            <span *ngIf="currentViewType !== 'list'" (click)="updateViewType('list')">
              <i class="icon icon-list toggle-list"></i>
            </span>
                    <span *ngIf="currentViewType !== 'map'" (click)="updateViewType('map')">
              <i class="icon icon-map toggle-map"></i>
            </span>
                    </span>
                </div>
            </div>

            <div class="hidden-xs hidden-sm col-md-8">
                <job-search-filters [(availableFilters)]="filters" [themeColor]="themeColor" (applyFilters)="updateQueryParams()" (resetFilter)="resetFilter($event)">
                </job-search-filters>
            </div>
        </div>

        <div id="job-search-bar-container" class="row">
            <div class="col-xs-12">
                <div id="job-search-bar" *ngIf="currentViewType === 'list' && hasListSearched || currentViewType === 'map' && hasMapSearched">
                    <strong *ngIf="!isTogglingViews && actualJobTotal > 1">{{actualJobTotal}} jobs</strong>
                    <div id="job-search-bar-filter-button" *ngIf="(currentViewType === 'map' && jobsSearchResultsMap.length > 0) || currentViewType === 'list'" class="hidden-md hidden-lg" (click)="jobSearchFilterMenu.toggleMobileFilterMenu()">
                        <i class="icon icon-filter"></i>
                        <span class="filter-count" *ngIf="totalSelectedOptions > 0" [style.background-color]="themeColor">{{totalSelectedOptions}}</span>
                    </div>
                </div>
            </div>
        </div>

    </ng-template>



    <div class="row" *ngIf="currentViewType === 'list'">
        <div class="col-sm-12">
            <jobs-search-results-list-view [jobResults]="jobsSearchResultsList" [jobTypeFilter]="jobTypeFilter" [config]="config" [themeColor]="themeColor" [currentLocation]="jobSearchParams.location" [showDistance]="showDistance" [hasSearched]="hasListSearched"></jobs-search-results-list-view>
        </div>
    </div>

    <div class="row" *ngIf="config.totalItems > config.itemsPerPage && currentViewType === 'list'">
        <div class="col-sm-12">
            <div id="pagination-container">
                <span>Showing 10 of {{config.totalItems}} jobs</span>
                <pagination-controls [id]="config.id" [maxSize]="5" (pageChange)="updateQueryParams($event)" previousLabel="" nextLabel=""></pagination-controls>
                <span>{{config.currentPage}} of {{ (config.totalItems / config.itemsPerPage) | round}}</span>
            </div>
        </div>
    </div>

    <div class="row" *ngIf="googleMapsIsLoaded && currentViewType === 'map' ">
        <div class="col-sm-12">
            <jobs-search-results-map-view *ngIf="!isSearching || hasMapSearched" [jobResults]="jobsSearchResultsMap" [themeColor]="themeColor" [hasSearched]="hasMapSearched" (newMapCoords)="newMapCoords($event)" (getLatLngFromGeoLocation)="getLatLngFromGeoLocation()"></jobs-search-results-map-view>
        </div>
    </div>
</div>